<template>
    <p class="my-5 lg:mt-12 mb-5 font-bold text-2xl lg:text-4xl 2xl:text-7xl" :class="[ options.color || '' || 'text-transparent bg-clip-text ' + 'bg-gradient-to-r', 'from-' + options.from, 'to-' + options.to, options.from, options.to]">
        <slot></slot>
    </p>
</template>

<script>
    export default {
        name: 'TitleSChapter',
        props: {
            options: null
        }
    };
</script>

<style lang="scss" scoped></style>
